import PropTypes from 'prop-types';
import { Box, Typography, Tooltip } from '@mui/material';
import { Iconify } from 'src/components';

export default function LostByTeamMember({ data }) {
    return (
        <Box
            sx={{
                bgcolor: '#fff',
                borderRadius: '16px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                overflow: 'hidden',
                mb: 3,
            }}
        >
            <Box sx={{ p: 2.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                <Tooltip title="Team members with the most lost leads." placement="bottom" arrow
                    slotProps={{ tooltip: { sx: { bgcolor: '#1e293b', fontSize: '12px', maxWidth: 280 } } }}>
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, cursor: 'help' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 700 }}>Lost by Team Member</Typography>
                        <Iconify icon="mdi:information-outline" width={14} sx={{ color: '#94a3b8' }} />
                    </Box>
                </Tooltip>
            </Box>
            <Box sx={{ p: 3 }}>
                {data.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography sx={{ color: '#64748b', fontSize: '14px' }}>
                            Team member loss data is not yet available. This feature will be available in a future update.
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        {data.map((member, idx) => (
                            <Box
                                key={member.name || idx}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    p: 1.5,
                                    borderRadius: '8px',
                                    bgcolor: '#f8fafc',
                                }}
                            >
                                <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>{member.name}</Typography>
                                <Box sx={{ display: 'flex', gap: 3 }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#ef4444' }}>
                                        {member.count} lost
                                    </Typography>
                                    <Typography sx={{ fontSize: '14px', color: '#64748b' }}>
                                        {member.topReason || '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    );
}

LostByTeamMember.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        count: PropTypes.number,
        topReason: PropTypes.string,
    })),
};

LostByTeamMember.defaultProps = {
    data: [],
};
